import './builder/bootstrap';
import { Quill } from '@vueup/vue-quill';
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';
// @ts-ignore
import htmlEditButton from "quill-html-edit-button";
// @ts-ignore
String.prototype.hashCode = function () {
    var hash = 0;
    if (this.length === 0) {
        return hash;
    }
    for (var i = 0; i < this.length; i++) {
        var char = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
window['getHash'] = (obj) => {
    // @ts-ignore
    return JSON.stringify(obj).hashCode();
};
window['quill-toolbar-config-full'] = [
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "super" }, { script: "sub" }],
    [{ header: "1" }, { header: "2" }, "blockquote", "span-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    ["link", "image", "video"],
    ["clean"],
];
Quill.register("modules/htmlEditButton", htmlEditButton);
window['quill-toolbar-config-lite'] = [
    ["bold", "italic", "underline", "strike"],
    [{ script: "super" }, { script: "sub" }],
    [{ list: "ordered" }, { list: "bullet" }]
];
window['initQuillEditors'] = (editors, toolbarConfig) => {
    editors.forEach((editor) => {
        let quill = new Quill(editor.id, {
            theme: 'snow',
            //contentType: 'html',
            modules: {
                toolbar: toolbarConfig,
                htmlEditButton: {
                    msg: 'Edit HTML',
                    buttonHTML: '<svg viewBox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class="ql-stroke" x1="10" x2="8" y1="5" y2="13"></line> </svg>',
                }
            }
        });
        quill.on('text-change', function (delta, oldDelta, source) {
            let input = document.getElementById(editor.input);
            const contents = quill.getContents();
            const converter = new QuillDeltaToHtmlConverter(contents.ops, {});
            input['value'] = converter.convert();
        });
    });
};
// auto-toggling of collapse icons
$('.collapse').on('hide.bs.collapse show.bs.collapse', (e) => {
    $(e.target)
        .parent()
        .find('[data-toggle="collapse"] i')
        .toggleClass('fa-chevron-circle-up fa-chevron-circle-down');
});
$(function () {
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="tooltip"]').on('mouseout', function (e) {
        $(e.target).tooltip('hide');
    });
    // @ts-ignore
    var clipboard = new Clipboard('.btn');
    // @ts-ignore
    clipboard.on('success', function (e) {
        $(e.trigger).tooltip('show');
    });
    const pickers = document.querySelectorAll('[data-picker]');
    pickers.forEach((el) => {
        const picker = new window['Pikaday']({
            field: el,
            format: 'MMM D, YYYY',
            maxDate: new Date()
        });
    });
    // check filter state
    if (window['store'].get('showFilters') === true) {
        $('#filter-body').addClass('show');
    }
    $('#filter-body').on('hide.bs.collapse', (e) => {
        console.log(e);
        window['store'].set('showFilters', false);
    });
    $('#filter-body').on('show.bs.collapse', (e) => {
        console.log(e);
        window['store'].set('showFilters', true);
    });
});
